/**
 * Teksten van de rondleiding bij het eerste bezoek. Jij-vorm, kort: één zin die
 * zegt wat er staat en één die zegt wat je er doet. Knoppen zijn werkwoorden.
 */
export const tourCopy = {
    /** De naam van de tekstballon voor een schermlezer. */
    label: 'Rondleiding',
    counter: (step: number, total: number) => `Stap ${step} van ${total}`,
    next: 'Volgende',
    back: 'Vorige',
    done: 'Klaar',
    skip: 'Overslaan',
    skipLabel: 'Rondleiding overslaan',
    /** Bij een smal scherm zit de navigatie achter de knop Menu. */
    inMenu: 'Je vindt dit onder Menu.',

    steps: {
        dashboard: {
            title: 'Je dashboard',
            body: 'Hier begin je elke dag. Je ziet wat er op je wacht en wat je nu het beste kunt doen.',
        },
        newInspection: {
            title: 'Nieuwe keuring',
            body: 'Hiermee maak je een keuring aan: klant, adres en dienst. Inplannen kan meteen of later.',
        },
        inspections: {
            title: 'Keuringen',
            body: 'Al je keuringen op één plek, van aanvraag tot verstuurd rapport. Open er een voor de opname, het rapport en de klantpagina.',
        },
        planning: {
            title: 'Planning',
            body: 'Plan keuringen in en zie welke inspecteur wanneer op pad is.',
        },
        billing: {
            title: 'Facturatie',
            body: 'Je abonnement, je tegoed aan keuringen en je facturen. Hier koop je ook extra keuringen.',
        },
        settings: {
            title: 'Instellingen',
            body: 'Je bedrijfsgegevens en je huisstijl. Ze staan op elk rapport, dus vul ze als eerste in.',
        },
        myDay: {
            title: 'Mijn dag',
            body: 'Je keuringen van vandaag, op volgorde. Hier begin je als je op pad gaat.',
        },
        startSurvey: {
            title: 'Een opname starten',
            body: 'Open een keuring en tik op Keuring starten. De vragenlijst staat daarna op dit apparaat en je vult hem ter plekke in.',
        },
        sync: {
            title: 'Werkt ook zonder internet',
            body: 'Wat je invult, staat meteen veilig op dit apparaat. Hier zie je of alles is verstuurd: zodra er weer verbinding is, synchroniseert de app vanzelf.',
        },
        account: {
            title: 'Je account',
            body: 'Je wachtwoord en je apparaten. Hier kun je deze rondleiding ook opnieuw bekijken.',
        },
    },
} as const;
